import { render, staticRenderFns } from "./get2020-11-11.vue?vue&type=template&id=fdb23d70&scoped=true&"
import script from "./get2020-11-11.vue?vue&type=script&lang=ts&"
export * from "./get2020-11-11.vue?vue&type=script&lang=ts&"
import style0 from "./get2020-11-11.vue?vue&type=style&index=0&id=fdb23d70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdb23d70",
  null
  
)

export default component.exports